import apiService from "./ApiService"
import { createQS } from "./Utils"

// SDD 039 - quantidade de itens na aba "Avisos" do arquivo, informada pela API num header
const quantidadeAvisos = (headers) => Number(headers?.['x-relatorio-avisos']) || 0

class RelatorioService {
  async gerarPorFiltros(idContrato, filtros) {
    const qs = createQS({
      numero: filtros.numero,
      ano: filtros.ano,
      idEmpresa: filtros.idEmpresa,
      idEquipe: filtros.idEquipe,
      osInicio: filtros.osInicio,
      osFim: filtros.osFim,
      idStatus: filtros.idStatus,
      dataInicio: filtros.dataInicio?.toISOString().substring(0, 10),
      dataFim: filtros.dataFim?.toISOString().substring(0, 10)
    })

    try {
      const headers = await apiService.getBlob(`relatorio/por_filtros/${idContrato}?${qs}`, 'relatorio.xlsx')
      return quantidadeAvisos(headers)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gerarPorLote(idLote, dataInicio, dataFim) {
    const qs = createQS({
      dataInicio: dataInicio?.toISOString().substring(0, 10),
      dataFim: dataFim?.toISOString().substring(0, 10)
    })

    try {
      const headers = await apiService.getBlob(`relatorio/por_lote/${idLote}?${qs}`, 'relatorio.zip')
      return quantidadeAvisos(headers)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }


  async gerarPorOS(idContrato, idOS) {
    try {
      const headers = await apiService.getBlob('relatorio/por_os/' + idOS + '?idContrato=' + idContrato, 'relatorio.xlsx')
      return quantidadeAvisos(headers)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gerarPorCruzamento(idContrato, idCruzamento) {
    try {
      const headers = await apiService.getBlob('relatorio/por_cruzamento/' + idCruzamento + '?idContrato=' + idContrato, 'relatorio.xlsx')
      return quantidadeAvisos(headers)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gerarFotografico(idOS) {
    try {
      await apiService.getBlob('relatorio/fotografico/' + idOS, 'relatorio_fotografico.pdf')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async gerarMedicao(idOS) {
    try {
      await apiService.getBlob('relatorio/medicao/' + idOS, 'relatorio_medicao.pdf')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

}

const relatorioService = new RelatorioService()
export default relatorioService